import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
})

const adminAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/admin',
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
})

const blobInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'blob',
})

export default instance
export { adminAPI, blobInstance }
